import React, {memo,} from 'react'
import Language from "language"
import styled from "styled-components"

import {Popover,} from "antd";
import {IconContainer} from "@biron-data/react-components";
import {QuestionCircleOutlined} from "@ant-design/icons";

interface Props {
}


const UserDetailsDescription = memo<Props>(function UserDetailsDescription() {
  return <Popover
    placement={"left"}
  content={
    <PopoverContent>
      <Title>{Language.get("admin.user.content.rightsInfoDescription.datamodel.title")}</Title>
      <div>{Language.get("admin.user.content.rightsInfoDescription.datamodel.firstText")}</div>
      <ul>
        <li>{Language.get("admin.user.content.rightsInfoDescription.datamodel.firstList.first")}</li>
        <li>{Language.get("admin.user.content.rightsInfoDescription.datamodel.firstList.second")}</li>
        <li>{Language.get("admin.user.content.rightsInfoDescription.datamodel.firstList.third")}</li>
      </ul>
      <DivWithEndPadding>{Language.get("admin.user.content.rightsInfoDescription.datamodel.secondText")}</DivWithEndPadding>
      <div>{Language.get("admin.user.content.rightsInfoDescription.datamodel.secondListTitle")}</div>
      <ul>
        <li><PrimarySpan>{Language.get("admin.user.content.rightsInfoDescription.datamodel.secondList.first")}</PrimarySpan></li>
        <li><PrimarySpan>{Language.get("admin.user.content.rightsInfoDescription.datamodel.secondList.second")}</PrimarySpan></li>
      </ul>
      <Title>{Language.get("admin.user.content.rightsInfoDescription.workspace.title")}</Title>
      <div>{Language.get("admin.user.content.rightsInfoDescription.workspace.firstListTitle")}</div>
      <ul>
        <li>{Language.get("admin.user.content.rightsInfoDescription.workspace.firstList.first")}</li>
        <li>{Language.get("admin.user.content.rightsInfoDescription.workspace.firstList.second")}</li>
        <li>{Language.get("admin.user.content.rightsInfoDescription.workspace.firstList.third")}</li>
      </ul>
      <div>{Language.get("admin.user.content.rightsInfoDescription.workspace.secondListTitle")}</div>
      <ul>
        <li><PrimarySpan>{Language.get("admin.user.content.rightsInfoDescription.workspace.secondList.first")}</PrimarySpan></li>
        <li><PrimarySpan>{Language.get("admin.user.content.rightsInfoDescription.workspace.secondList.second")}</PrimarySpan></li>
        <li><PrimarySpan>{Language.get("admin.user.content.rightsInfoDescription.workspace.secondList.third")}</PrimarySpan></li>
      </ul>
    </PopoverContent>}>
    <Trigger>{Language.get("admin.user.content.rightsInfoTitle")}<IconContainer><QuestionCircleOutlined/></IconContainer></Trigger>
  </Popover>
})

export default UserDetailsDescription

const Trigger = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 23px;
    letter-spacing: -2%;
    display: flex;
    color: var(--primary);
    gap: 10px;
`

const PopoverContent = styled.div`
  max-width: 550px;
    overflow: hidden;
    padding: 30px;
    font-family: Poppins;
    font-weight: 400;
    font-size: 14px;
    line-height: 23px;
    letter-spacing: -2%;

`


const Title = styled.div`
    font-weight: 500;
    font-size: 16px;
    line-height: 23px;
    letter-spacing: -2%;
    padding-bottom: 15px;
`

const PrimarySpan = styled.span`
  color: var(--primary);
  `

const DivWithEndPadding = styled.div`
    padding-bottom: 14px;
`